import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { CommonService } from '../common.service';
import * as moment from 'moment';
import { FormBuilder,FormGroup,FormControl,Validators } from '@angular/forms';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { BrowserModule } from '@angular/platform-browser';
declare var $: any;
declare let swal:any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Component({
  selector: 'app-stockmanagement',
  templateUrl: './stockmanagement.component.html',
  styleUrls: ['./stockmanagement.component.css']
})
export class StockmanagementComponent implements OnInit {
  name = 'This is XLSX TO JSON CONVERTER';
  willDownload = false;
  samepageroute="/dashboard/stockmanagement"
  returnUrl= "/dashboard/addstockmanagement";
  viewurl="/dashboard/viewstockmanagement";
  editurl="/dashboard/editstockmanagement";
  backurl="/dashboard/mastermodule";
  boxUrl="/dashboard/animalmanagement";
  getlistApi:any;
  addUrl:any;
  dataString:any;
  getStockListData:any=[];
  table:any;
  loginresponse:any;
  userrole:any;
  loadspeciesValue:any;
  farm_userrole:any;
  isDisabled:boolean=false;
  farm_user:any;
  getspeciesid:any;
  getfarmsListData:any=[];
  breedgetlistApi:any;
  getbreedListData:any=[];
  uniquebreedsarray:any=[];
  listspeciesname:any=[];
  listbreedid:any;
  user_id:any;
  farmcodeforvalidation:any;
  dynamicfarmid:any;
  dynamicspeciesid:any;
  dynamicagegroupid:any;
  listbreedname:any=[];
  listfarmname:any=[];
  loadagegroupvalue:any=[];
  dynamicbreedid:any;
  exceldublicatfunarr:any=[];
  exceldublicatfunarrtable:any=[];
  getspeciesListData:any=[];
  farmListID:any=[];
  agegruptype:any;
  tnageid:any;
  tnagtimerange:any;
  getbreedvalueres:any=[];
  speciesloaddata:any=[];
  stockbulkdata=[]
  agegroupgetlistApi:any;
  agegroupListData:any=[];
  isLoading =false
  constructor(private router: Router,private commonService: CommonService) { }

  async ngOnInit() {
    
     // farm list api start
     $('.selectpicker').selectpicker('refresh');
   this.getlistApi= "/farms";
   (await this.commonService.getApi(this.getlistApi)).subscribe(
     (res) => {
         this.getfarmsListData = res.data;
       
        }) 
      // farm list api end
        // species list api start
        this.getlistApi="/species";
        (await this.commonService.getApi(this.getlistApi)).subscribe(
          (res) => {
              this.getspeciesListData = res.data;
            
             }) 
        // species list api end
          // breed list api start
        this.breedgetlistApi="/breeds";
        (await this.commonService.getApi(this.breedgetlistApi)).subscribe(
          (res) => {
              this.getbreedListData = res.data;
            
             }) 
             this.agegroupgetlistApi="/species/age_group/list";
        (await this.commonService.getApi(this.agegroupgetlistApi)).subscribe(
          (res) => {
              this.agegroupListData = res.data;
            
             }) 
 
                  // breed list api end
    this.isLoading =true;
    var table;
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.user_id=this.loginresponse.user_id;
    this.userrole=this.loginresponse.read_status;
    this.farmcodeforvalidation=this.loginresponse.user_farm_code;
    this.farm_userrole=this.loginresponse.user_farm_id;
    if(this.userrole==1){
     this.isDisabled = true;
      // $(".edit").removeAttr("id"); // Element(s) are now enabled.
    }
    if(this.userrole==0){
     this.isDisabled=false;
      // $(".edit").removeAttr("id"); // Element(s) are now enabled.
    }
    this.farm_user=this.farm_userrole;
    if(this.farm_user){
     this.getlistApi= "/stock_management/?farm_user="+this.farm_user;
    }
   else{
     this.getlistApi= "/stock_management";
   }
   // this.getlistApi= "/stock_management";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {
        setTimeout((res)=>{ 
          this.isLoading =false;
    }, 500);
         $(function(){
         table = $("#myTable").DataTable();
         })
          this.getStockListData = res.data;                          
         }) 
       $('#speciessearch').on( 'keyup', function () {
     var inputValue =(<HTMLInputElement>document.getElementById('speciessearch')).value;
    table.search( inputValue ).draw();
 });
 $(document).on('click', '.dropdown-menu', function (e) {
  e.stopPropagation();
});
 $("#dropdwnhideshow > li").click(function() {
   $(this).find("ul.assignments").toggleClass('hide');
 });
 
 }

  addstockmanagement(){
    this.router.navigate([this.returnUrl]);
  }
  viewstockmanagement(e){
 
    sessionStorage.setItem('StockId',e.target.id);
    this.router.navigate([this.viewurl]);
  }
  editstockmanagement(e){

    sessionStorage.setItem('StockId',e.target.id);
    this.router.navigate([this.editurl]);
  }
  boxview(){
    this.router.navigate([this.boxUrl]);
  }
  backtomastermodule(){
    this.router.navigate([this.backurl]);
  }
 async sweetdelete(e){
    Swal.fire({  
      title: 'Are you sure you want to delete the Stock record ?',  
     // text: 'You will not be able to recover this file!',  
      icon: 'warning',  
      showCancelButton: true,  
      confirmButtonText: 'Yes',  
      cancelButtonText: 'No'  
    }).then( async (result) => {  
      if (result.value) {  

        var deleteurl = "/stock_management/"+e.target.id;
        (await this.commonService.deleteApi(deleteurl)).subscribe(
          res => {
            Swal.fire(  
              'Deleted!',  
              'The Stock record has been deleted successfully',  
              'success'  
            );
            let currentUrl = this.samepageroute;
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
                this.router.navigate([currentUrl]);
          });     
          })              
        
      } else if (result.dismiss === Swal.DismissReason.cancel) {  
        Swal.fire(  
          'Cancelled',  
          'The Stock record has not been deleted',  
          'error'  
        )  
      }  
    })  }

//search filter dynamic data load start
    async getfarmvalue(e){
      this.isLoading =true;
     /* this.loadspeciesValue={
        "farms_id":e.target.value
      }
      this.addUrl = "/species/farms";
      (await this.commonService.postApi(this.addUrl,this.loadspeciesValue)).subscribe(
        res => {
          this.speciesloaddata=res.data;
          console.log( this.speciesloaddata)
        })*/

      this.getStockListData=[]
      $('#myTable').dataTable().fnDestroy();
      this.dynamicfarmid=e.target.value
      var table;
      if(this.farm_userrole){
        alert()
        this.getlistApi="/stock_management/all_data/filters/?farm_id="+this.farm_userrole+"&species_id="+null+"&age="+null+"&breed_id="+null+"";

       }else{
        this.getlistApi="/stock_management/all_data/filters/?farm_id="+this.dynamicfarmid+"&species_id="+null+"&age="+null+"&breed_id="+null+"";
       }
      (await this.commonService.getApi(this.getlistApi)).subscribe(
        res => {
          setTimeout((res)=>{ 
            this.isLoading =false;
            table = $("#myTable").DataTable();
        }, 500);  
        this.getStockListData = res.data;           
           }) 
    }
    async getspeciesvalue(e){
      this.isLoading =true;
      this.getspeciesid=e.target.value;
    /*this.addUrl = "/breeds/species/"+this.getspeciesid;
    (await this.commonService.getApi(this.addUrl)).subscribe(
      res => {
           this.getbreedvalueres=res.data;
          console.log(this.getbreedvalueres);
      });
      this.addUrl = "/species/age_group/all_category/?species_id="+this.getspeciesid;
      (await this.commonService.getApi(this.addUrl)).subscribe(
        res => {
             this.loadagegroupvalue=res.data;
        });*/

      this.getStockListData=[]
      $('#myTable').dataTable().fnDestroy();
      this.dynamicspeciesid=e.target.value
      var table;
      if(this.farm_userrole){
        this.getlistApi="/stock_management/all_data/filters/?farm_id="+null+"&species_id="+this.dynamicspeciesid+"&age="+null+"&breed_id="+null+"";

      }else{
        this.getlistApi="/stock_management/all_data/filters/?farm_id="+null+"&species_id="+this.dynamicspeciesid+"&age="+null+"&breed_id="+null+"";
      }
      (await this.commonService.getApi(this.getlistApi)).subscribe(
        res => {
          setTimeout((res)=>{ 
            this.isLoading =false;
            table = $("#myTable").DataTable();
        }, 500);  
        this.getStockListData = res.data;           
           }) 
    }
    async getbreedvalue(e){
      this.isLoading =true;
    
      this.getStockListData=[]
      $('#myTable').dataTable().fnDestroy();
      this.dynamicbreedid=e.target.value
      var table;
      if(this.farm_userrole){
        this.getlistApi="/stock_management/all_data/filters/?farm_id="+null+"&species_id="+null+"&age="+null+"&breed_id="+this.dynamicbreedid+"";

      }
else{
  this.getlistApi="/stock_management/all_data/filters/?farm_id="+null+"&species_id="+null+"&age="+null+"&breed_id="+this.dynamicbreedid+"";

}
      (await this.commonService.getApi(this.getlistApi)).subscribe(
        res => {
          setTimeout((res)=>{ 
            this.isLoading =false;
            table = $("#myTable").DataTable();
        }, 500);  
        this.getStockListData = res.data;           
           }) 
    }
    async getagegroup(e){
      this.isLoading =true;
    
      this.getStockListData=[]
      $('#myTable').dataTable().fnDestroy();
      this.dynamicagegroupid=e.target.value
      var table;
      if( this.dynamicbreedid==undefined){
        var breedid=null;
            }else{
              var breedid=this.dynamicbreedid;
            }
            if(this.farm_userrole){
              this.getlistApi="/stock_management/all_data/filters/?farm_id="+null+"&species_id="+null+"&age="+this.dynamicagegroupid+"&breed_id="+null+"";
      
            }else{
              this.getlistApi="/stock_management/all_data/filters/?farm_id="+null+"&species_id="+null+"&age="+this.dynamicagegroupid+"&breed_id="+null+"";

            }
      (await this.commonService.getApi(this.getlistApi)).subscribe(
        res => {
          setTimeout((res)=>{ 
            this.isLoading =false;
            table = $("#myTable").DataTable();
              table.rows( {page:'current'} ).data();  
        }, 500);  
        this.getStockListData = res.data;           
           }) 
    }
//search filter dynamic data load start
 //bulk upload import data from excel start
    
 async importbulkdatafromexcel(ev) {
 
  this.getspeciesListData;
  var uniquerSpeciesformarray=[];
  var uniquespeciesarray=[];
  var uniquebreedsarray=[];
  var sweetalert=[];
  var breedfarmname_speciesname_breedname=[];
  var farmname_speciesname_animalid=[];
  var bname_speciesname_aid_fname=[];
 
  for(var i=0;i<this.getfarmsListData.length;i++){
    var farmname1=String(this.getfarmsListData[i].tnfr_code).trim().toLowerCase();
      uniquerSpeciesformarray.push(farmname1);

}
for(var i=0;i<this.getspeciesListData.length;i++){
var speciesname=String(this.getspeciesListData[i].speciesID).trim().toLowerCase();
uniquespeciesarray.push(speciesname);

}
for(var i=0;i<this.getbreedListData.length;i++){
  var breedname=String(this.getbreedListData[i].breedID).trim().toLowerCase();
  uniquebreedsarray.push(breedname);
   
  }
  for(var i=0;i<this.getStockListData.length;i++){
       var farmname=String(this.getStockListData [i].farm_code).trim().toLowerCase();
       var speciesname1=String(this.getStockListData [i].species_code).trim().toLowerCase();
       var breedname1=String(this.getStockListData [i].breed_code).trim().toLowerCase();
       var animalid=String(this.getStockListData [i].tnsm_animal_code).trim().toLowerCase();
       this.listspeciesname.push(speciesname1);
       this.listbreedname.push(breedname1);
       this.listfarmname.push(farmname);
       breedfarmname_speciesname_breedname.push(farmname+'_'+speciesname1+'_'+breedname1);
       farmname_speciesname_animalid.push(farmname+'_'+speciesname1+'_'+animalid);
       bname_speciesname_aid_fname.push(farmname+'_'+speciesname1+'_'+breedname1+'_'+animalid)
// console.log(bname_speciesname_aid_fname)
  }

  let workBook = null;
  let jsonData = null;
  const reader = new FileReader();
  const file = ev.target.files[0];
  reader.onload = async (event) => {
    const data =reader.result;
    workBook = XLSX.read(data, { type: 'binary' });
    jsonData = workBook.SheetNames.reduce((initial, name) => {
      const sheet = workBook.Sheets[name];
      initial[name] = XLSX.utils.sheet_to_json(sheet);
      return initial;
    }, {});
    var uploadexcelarray=Object.values(jsonData)[0];
this.dataString ={data:uploadexcelarray}
// console.log(this.dataString);
 //future date compare start

  /*  document.write("g1 is lesser than g2");
else if (g1.getTime() > g2.getTime())
    document.write("g1 is greater than g2");
else
    document.write("both are equal");*/
    //future date compare end
//        let value:any=dataString;
// console.log(this.dataString);
    var excelFnameSnmeBname=[];
    var excelFnameSnameAid=[];
    var excelFnameSnameBnameAId=[];
    var excelfarmuniquename=[];
    var excelspeciesuniquename=[];
    var wrongfarmid=[];
    var birthdatevalidatefuture=[];
    var excelbreeduniquename=[];
    if(this.farm_userrole){
    for(var i=0;i<this.dataString.data.length;i++){
      if (this.dataString.data[i]["Farm id"].trim().toLowerCase() == this.farmcodeforvalidation.trim().toLowerCase()) {
      var farmnameexcel=String(this.dataString.data[i]["Farm id"]).trim().toLowerCase()
      var speciesnameexcel=String(this.dataString.data[i]["Species id"]).trim().toLowerCase()
      var breednameexcel=String(this.dataString.data[i]["Breed id"]).trim().toLowerCase()
      var animalidnameexcel=String(this.dataString.data[i]["Animal code"]).trim().toLowerCase()
      var dateofbirth=String(this.dataString.data[i]["Date of birth"]).trim().toLowerCase()
      excelFnameSnmeBname.push(farmnameexcel+'_'+speciesnameexcel+'_'+breednameexcel);
      excelFnameSnameAid.push(farmnameexcel+'_'+speciesnameexcel+'_'+animalidnameexcel)
      excelFnameSnameBnameAId.push(farmnameexcel+'_'+speciesnameexcel+'_'+breednameexcel+'_'+animalidnameexcel);   
       excelfarmuniquename.push(farmnameexcel);
    excelspeciesuniquename.push(speciesnameexcel);
    birthdatevalidatefuture.push(dateofbirth);
    excelbreeduniquename.push(breednameexcel);
    }
    else{
      wrongfarmid.push(this.dataString.data[i]["Farm id"].trim().toLowerCase())
      // console.log( wrongfarmid)
    }
  }
  if(wrongfarmid.length!==0){
    sweetalert.push("Entered Incorrect Farm Id")
  }
  }
  if(!this.farm_userrole){
    for(var i=0;i<this.dataString.data.length;i++){
      var farmnameexcel=String(this.dataString.data[i]["Farm id"]).trim().toLowerCase()
      var speciesnameexcel=String(this.dataString.data[i]["Species id"]).trim().toLowerCase()
      var breednameexcel=String(this.dataString.data[i]["Breed id"]).trim().toLowerCase()
      var animalidnameexcel=String(this.dataString.data[i]["Animal code"]).trim().toLowerCase()
      var dateofbirth=String(this.dataString.data[i]["Date of birth"]).trim().toLowerCase()
      // console.log(dateofbirth);
      excelFnameSnmeBname.push(farmnameexcel+'_'+speciesnameexcel+'_'+breednameexcel);
      excelFnameSnameAid.push(farmnameexcel+'_'+speciesnameexcel+'_'+animalidnameexcel)
      excelFnameSnameBnameAId.push(farmnameexcel+'_'+speciesnameexcel+'_'+breednameexcel+'_'+animalidnameexcel);   
       excelfarmuniquename.push(farmnameexcel);
    excelspeciesuniquename.push(speciesnameexcel);
    birthdatevalidatefuture.push(dateofbirth);
    excelbreeduniquename.push(breednameexcel);
    }
  }
    //unique farm check start
       
var differentfarmdata = [];

// var difference = [];
for( var i = 0; i < excelfarmuniquename.length; i++ ) {
  if( $.inArray( excelfarmuniquename[i], uniquerSpeciesformarray ) == -1 ) {
    differentfarmdata.push(excelfarmuniquename[i]);

  }
}

var result ="";
if(differentfarmdata){
for(var i=0;i<differentfarmdata.length;i++){
result +="Farm Id '"+differentfarmdata[i]+"' doesn't exist<br>"

}
}
if(result){
//Swal.fire("Wrong Farm Selection",result);
sweetalert.push(result)

}
//unique farm check end

//futurebirthdateset
  
   var futurebirthdate = [];

   for( var i = 0; i < birthdatevalidatefuture.length; i++ ) {
   // var GivenDate = birthdatevalidatefuture[i];
    var date1:any=moment(birthdatevalidatefuture[i]).format('YYYY/MM/DD');
var date2:any= moment().format('YYYY/MM/DD');
if(moment(date1).isAfter(date2)) {
 futurebirthdate.push(date1);
} 
   }
   var result ="";
   if(futurebirthdate){
   for(var i=0;i<futurebirthdate.length;i++){
   result +="Some of your entries in your recent activity is  invalid!! line number '"+ [i]+2 +"'"
   }
   }
   if(result){
   //Swal.fire("Wrong Farm Selection",result);
   sweetalert.push(result)
   
   }
   //future birth date end

//unique species check start
var differentspeciesdata=[];
for( var i = 0; i < excelspeciesuniquename.length; i++ ) {
  if( $.inArray( excelspeciesuniquename[i], uniquespeciesarray ) == -1 ) {
    differentspeciesdata.push(excelspeciesuniquename[i]);

  }
}

var resultspecies ="";
if(differentspeciesdata){
for(var i=0;i<differentspeciesdata.length;i++){
resultspecies +="Species Id '"+differentspeciesdata[i]+"' doesn't exist<br>"

}
}
if(resultspecies){
sweetalert.push(resultspecies)
}
//unique species check end
//unique breed check start
var differentbreeddata=[];
for( var i = 0; i < excelbreeduniquename.length; i++ ) {
  if( $.inArray( excelbreeduniquename[i], uniquebreedsarray ) == -1 ) {
    differentbreeddata.push(excelbreeduniquename[i]);
  }
}

var resultbreeds ="";
if(differentbreeddata){
for(var i=0;i<differentbreeddata.length;i++){
  resultbreeds +="Breed Id '"+differentbreeddata[i]+"' doesn't exist<br>"

}
}
if(resultbreeds){
//Swal.fire("Wrong Farm Selection",resultbreeds);
sweetalert.push(resultbreeds)
}
//unique breed check end
//dublicate species,breeds,fname start
    //console.log(excelUniquecheck);
   /* this.exceldublicatevaluecheck(excelFnameSnmeBname)
console.log(this.exceldublicatfunarr);
var result1 = "";
if(this.exceldublicatfunarr){
for(var i=0;i<this.exceldublicatfunarr.length;i++){
 var getduplicatevalue=this.exceldublicatfunarr[i].split('_');
 var farmnamedublicate=getduplicatevalue[0];
 var speciesnamedublicate=getduplicatevalue[1];
 var breednamedublicate=getduplicatevalue[2];
 //var animaliddublicate=getduplicatevalue[3];
 result1 +="Farm Name "+farmnamedublicate+" Species Name "+speciesnamedublicate+" Bread Name "+breednamedublicate+"<br>"

}

}
if(result1){
//Swal.fire("Duplicate Values",result1);
console.log(result1)
sweetalert.push(result1)
}*/

this.exceldublicatevaluecheck(excelFnameSnameAid)

var resultanid = "";
if(this.exceldublicatfunarr){
for(var i=0;i<this.exceldublicatfunarr.length;i++){
 var getduplicatevalue=this.exceldublicatfunarr[i].split('_');
 var farmnamedublicate=getduplicatevalue[0];
 var speciesnamedublicate=getduplicatevalue[1];
 var animaliddublicate=getduplicatevalue[2];
 //var animaliddublicate=getduplicatevalue[3];
 resultanid +="Animal Id '"+animaliddublicate+"' entered multiple times<br>"

}

}
if(resultanid){
//Swal.fire("Duplicate Values",resultanid);

sweetalert.push(resultanid)
}

this.exceldublicatevaluecheck(excelFnameSnameBnameAId);


var result2 = "";
if(this.exceldublicatfunarr){
for(var i=0;i<this.exceldublicatfunarr.length;i++){
 var getduplicatevalue=this.exceldublicatfunarr[i].split('_');
 var farmnamedublicate=getduplicatevalue[0];
 var speciesnamedublicate=getduplicatevalue[1];
 var breednamedublicate=getduplicatevalue[2];
 var animaliddublicate=getduplicatevalue[3];
 result2 += "Animal Id '"+animaliddublicate+"' entered multiple times<br>"
}

}
if(result2){
//Swal.fire("Duplicate Values",result2);

sweetalert.push(result2)
}
//dublicate species,breeds,fname end

/*//dublicate species,breeds,fname start table
this.exceldublicatevaluecheckintable(excelFnameSnmeBname,breedfarmname_speciesname_breedname)
console.log(this.exceldublicatfunarrtable);
//console.log(uniquerSpeciesformarray);
var result3 = "";
if(this.exceldublicatfunarrtable){
for(var i=0;i<this.exceldublicatfunarrtable.length;i++){
 var getduplicatevalue=this.exceldublicatfunarrtable[i].split('_');
 var farmnamedublicate2=getduplicatevalue[0];
 var speciesnamedublicate2=getduplicatevalue[1];
 var breednamedublicate2=getduplicatevalue[2];
 //var animaliddublicate2=getduplicatevalue[3];
result3 += "Animal Id '"+animaliddublicate+"' entered multiple times<br>"
}
}
if(result3){
//Swal.fire("Duplicate Values",result3);
console.log(result3)
sweetalert.push(result3)
}*/

this.exceldublicatevaluecheckintable(excelFnameSnameAid,farmname_speciesname_animalid)

var resultanidtable = "";
if(this.exceldublicatfunarrtable){
for(var i=0;i<this.exceldublicatfunarrtable.length;i++){
 var getduplicatevalue=this.exceldublicatfunarrtable[i].split('_');
 var farmnamedublicate=getduplicatevalue[0];
 var speciesnamedublicate=getduplicatevalue[1];
 var animaliddublicate=getduplicatevalue[2];
 //var animaliddublicate=getduplicatevalue[3];
 resultanidtable += "Animal Id '"+animaliddublicate+"' entered multiple times<br>"

}

}
if(resultanidtable){
//Swal.fire("Duplicate Values",resultanidtable);

sweetalert.push(resultanidtable)
}


this.exceldublicatevaluecheckintable(excelFnameSnameBnameAId,bname_speciesname_aid_fname)

var result4 = "";
if(this.exceldublicatfunarrtable){
for(var i=0;i<this.exceldublicatfunarrtable.length;i++){
 var getduplicatevalue=this.exceldublicatfunarrtable[i].split('_');
 var farmnamedublicate2=getduplicatevalue[0];
 var speciesnamedublicate2=getduplicatevalue[1];
 var breednamedublicate2=getduplicatevalue[2];
 var animaliddublicate2=getduplicatevalue[3];
 if(animaliddublicate2!=undefined){
  result4 +="Animal Id '"+animaliddublicate2+"' entered multiple times<br>"
 }
}
}
if(result4){
 // Swal.fire("Duplicate Values",result4);
 
  sweetalert.push(result4)
}

//dublicate species id and breed entry check in list table with farm id end
var finalvalidatevalue='';
for(var i=0;i<sweetalert.length;i++){
  finalvalidatevalue+=sweetalert[i]+"<br>";
}
if(finalvalidatevalue){
  Swal.fire("Duplicate values",finalvalidatevalue);
  let currentUrl = this.samepageroute;
  this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
});   
}else{
var stockbulkdata=[]
    for(var ind=0;ind<this.dataString.data.length;ind++){

  // console.log("index data", this.dataString.data.length, this.dataString.data)
    var updatestatus=this.dataString.data[ind].Status.toLowerCase();
    if(updatestatus=="active"){
      this.dataString.data[ind].Status = 1
      }else{
      this.dataString.data[ind].Status = 0
      }
     var obj =this.dataString.data[ind];
  
  this.getlistApi= "/species/age_group/filter_bulk/?dob="+this.dataString.data[ind]['Date of birth']+"&species_id="+this.dataString.data[ind]['Species id'];
  const res:any=await (await this.commonService.getApi(this.getlistApi)).toPromise();
  
      this.agegruptype=res.data[0].age_group_type;
      this.tnageid=res.data[0].tnag_id;
      this.tnagtimerange=res.data[0].tnag_time_range;   
       const new_obj= Object.assign(obj, {cby:this.user_id,age_group_type:this.agegruptype,time_range:this.tnagtimerange,age:this.tnageid});
      new_obj.age_group_type = this.agegruptype;
      Object.keys(obj).map(k => obj[k] = typeof obj[k] == 'string' ? obj[k].trim() : obj[k]);
      stockbulkdata.push(new_obj);

}    

this.addUrl = "/stock_management/bulk"; 
const resstock:any=await(await this.commonService.postApi(this.addUrl,stockbulkdata)).toPromise()
      alert(resstock.message);
  let currentUrl = this.samepageroute;
  this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
  });   
}
 
 /* this.addUrl = "/species";
(await this.commonService.postApi(this.addUrl,this.dataString.data)).subscribe(
  data => {
      alert(data.message);
  });*/

   // document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");
   
  }
  reader.readAsBinaryString(file);
}
    

//function for duplicate value fintout in excel start
  
 exceldublicatevaluecheck(excelFnameSnmeBname){
  const arry = excelFnameSnmeBname;
  const toFindDuplicates = arry => arry.filter((item, index) => arry.indexOf(item) !== index)
const duplicateElementa = toFindDuplicates(arry);
this.exceldublicatfunarr = duplicateElementa; 
}    
exceldublicatevaluecheckintable(excelFnameSnmeBname,breedfarmname_specisid_breedname){
//  console.log(excelFnameSnmeBname)
 // console.log(breedfarmname_specisid_breedname)
  for( var i = 0; i < excelFnameSnmeBname.length; i++ ) {
    if( $.inArray( excelFnameSnmeBname[i], breedfarmname_specisid_breedname ) !== -1 ) {

      this.exceldublicatfunarrtable.push(excelFnameSnmeBname[i]);
    }
  }
}
//function for duplicate value fintout in excel end


    exportspecies(){
      var downloadtabledata=this.getStockListData;
      var resultarry=downloadtabledata.map((ele)=>{
        var birthdate=ele.tnsm_date_of_birth.split('T');
        if(ele.tnsm_date_of_transfer!=null){
          var transferdate=ele.tnsm_date_of_transfer.split('T');
          var gettransferdate=transferdate[0];
        }
        if(ele.tnsm_date_of_purchase!=null){
        var purchasedate=ele.tnsm_date_of_purchase.split('T');
        var getpurchasedate=purchasedate[0];
        }
        if(ele.tnsm_date_of_deletion!=null){
          var deletiondate=ele.tnsm_date_of_deletion.split('T');
          var getdeletiondate=deletiondate[0];
        }
        if(ele.death_date!=null){
          var mortalitydate=ele.death_date.split('T');
          var getmortalitydate=mortalitydate[0];
        }

        if (ele.tnsm_status ==1){
          var statusc="Active";
        }else{
          var statusc="Inactive";
        }
        return {"Farm name":ele.farm_name,"Species name":ele.species_name,"Breed name":ele.breed_name,"DOB":birthdate[0],"age group":ele.tnsm_age,"Animal id":ele.tnsm_animal_code,"gender":ele.tnsm_sex,"weight":ele.tnsm_weight,"DOT":gettransferdate,"DOP":getpurchasedate,"DOD":getdeletiondate,"Status":statusc,"Date of death":getmortalitydate}
      })
  
      this.exportAsExcelFile(resultarry, 'Stock');
    }
    public exportAsExcelFile(json: any[], excelFileName: string): void {
    
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    
      const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
      this.saveAsExcelFile(excelBuffer, excelFileName);
    }
  
    private saveAsExcelFile(buffer: any, fileName: string): void {
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    }
    currentpageroute(){
      let currentUrl = this.samepageroute;
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
          this.router.navigate([currentUrl]);
      });
    }


  }

